

import { Emit, Component, Prop, Vue } from 'vue-facing-decorator';
import VendorListDivider from './VendorListDivider.vue';
import PurposeItem from './PurposeItem.vue';
import SpecialPurposeItem from './SpecialPurposeItem.vue';
import FeatureItem from './FeatureItem.vue';
import SpecialFeatureItem from './SpecialFeatureItem.vue';
import {TCModel} from '@iabtechlabtcf/core';

@Component({
  components: {
    VendorListDivider,
    PurposeItem,
    SpecialPurposeItem,
    FeatureItem,
    SpecialFeatureItem,
  },
})

export default class LayerTwo extends Vue {
  dirty=false;
  purposes : any[] = [] 
  specialPurposes : any[] = [] 
  features : any[] = [] 
  specialFeatures : any[] = [] 

  mounted() : void {

    console.log( "LayerTwo mounted()");
    
    //@ts-ignore
    console.log(window.__cmpTCModel.purposeConsents.set_);

    // @ts-ignore
    let model : TCModel = window.__cmpTCModel;

     // @ts-ignore
     if ( model && window.__GVL) {
      // @ts-ignore
      this.purposes = window.__GVL.purposes;
      // @ts-ignore
      this.specialPurposes = window.__GVL.specialPurposes;
      // @ts-ignore
      this.features = window.__GVL.features;
      // @ts-ignore
      this.specialFeatures = window.__GVL.specialFeatures;

      
      // @ts-ignore
    } else if ( model && model.purposes) {
      // @ts-ignore
      this.purposes = model.purposes;
      // @ts-ignore
      this.specialPurposes = model.specialPurposes;
      // @ts-ignore
      this.features = model.features;
      // @ts-ignore
      this.specialFeatures = model.specialFeatures;
    } 

  // console.log( this.$root.tcModel.gvl.purposes )
  // console.log( this.$root.tcModel.gvl.specialFeatures )
  }

  @Emit
	storeAcceptAllTCStringEvent() { }

  @Emit
	storeRejectAllTCStringEvent() { }

  @Emit
	storeTCStringEvent() { 

    console.log( "LayerTwo: storeTCStringEvent()");

  }


  @Emit('changeViewEvent')
  partnersClick() {
    return( "layerThree");
  }

  handleModelChangeEvent( value: boolean ) {
    this.dirty=true;
  }

  @Emit('changeViewEvent')
  saveAndExitClick() {
//@ts-ignore
    if (window.__GVL && window.__GVL.vendors) {
//@ts-ignore
      const allVendorIds = Object.keys(window.__GVL.vendors).map((id) => Number(id)).filter((id) => Number.isFinite(id) && id > 0);
//@ts-ignore
      if (typeof this.$root.__markDisclosedVendorIds === 'function') {
//@ts-ignore
        this.$root.__markDisclosedVendorIds(allVendorIds);
      }
    }
    this.storeTCStringEvent();
    return( "close");
  }

  @Emit('changeViewEvent')
  rejectAllClick() {
//@ts-ignore
    if (window.__GVL && window.__GVL.vendors) {
//@ts-ignore
      const allVendorIds = Object.keys(window.__GVL.vendors).map((id) => Number(id)).filter((id) => Number.isFinite(id) && id > 0);
//@ts-ignore
      if (typeof this.$root.__markDisclosedVendorIds === 'function') {
//@ts-ignore
        this.$root.__markDisclosedVendorIds(allVendorIds);
      }
    }
		this.storeRejectAllTCStringEvent();
    return("close");
  }

  @Emit('changeViewEvent')
  vendorsClick() {
      return ("layerThree");
  }

  @Emit('changeViewEvent')
  acceptAllClick() {
//@ts-ignore
    if (window.__GVL && window.__GVL.vendors) {
//@ts-ignore
      const allVendorIds = Object.keys(window.__GVL.vendors).map((id) => Number(id)).filter((id) => Number.isFinite(id) && id > 0);
//@ts-ignore
      if (typeof this.$root.__markDisclosedVendorIds === 'function') {
//@ts-ignore
        this.$root.__markDisclosedVendorIds(allVendorIds);
      }
    }
//@ts-ignore
		this.storeAcceptAllTCStringEvent();

    return( "close");
  }

}
